import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";
import { _3_DAYS } from "../../../constants/durations";

export type RemindersQueryParams = {
  provider_id?: string;
  subject_id?: string;
  is_completed?: boolean;
};

export async function fetchReminders(params: RemindersQueryParams, spaceId: string) {
  let query = apiClient
    .from('reminders')
    .select()
    .eq('space_id', spaceId)
    .order('due_date', { ascending: params.is_completed ? false : true });

  if (params.provider_id) {
    query = query.eq('provider_id', params.provider_id);
  }

  if (params.subject_id) {
    query = query.eq('subject_id', params.subject_id);
  }

  if (params.is_completed !== undefined && params.is_completed !== null) {
    query = query.eq('is_completed', params.is_completed);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return data;
}

export default function useGetReminders(
  params: RemindersQueryParams = {},
  enabled?: boolean
) {
  const { currentSpace } = useSpace();

  return useQuery({
    queryKey: keys.list(params),
    queryFn: () => fetchReminders(params, currentSpace!.id),
    enabled: enabled !== undefined ? enabled && !!currentSpace?.id : !!currentSpace?.id,
    staleTime: _3_DAYS
  });
}
